module.exports = __webpack_public_path__ + "static/wms-7ce6f0287d5c16b463b34389f04bc473.png";